export default "__VITE_ASSET__czNfYzAF__"